import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useWhatsApp } from '../context/WhatsAppContext';
import api from '../utils/api';

const WHATSAPP_PHONE = '525545547772';

const WhatsAppFab = () => {
  const { message, estudio } = useWhatsApp();
  const [showTooltip, setShowTooltip] = useState(false);
  const [pulse, setPulse] = useState(true);

  // Mostrar tooltip automáticamente a los 3 segundos, ocultar a los 8
  useEffect(() => {
    const show = setTimeout(() => setShowTooltip(true), 3000);
    const hide = setTimeout(() => setShowTooltip(false), 9000);
    return () => {
      clearTimeout(show);
      clearTimeout(hide);
    };
  }, []);

  const handleClick = () => {
    setPulse(false);

    // Fire-and-forget analytics tracking (no bloquea el click)
    try {
      api.post('/whatsapp-analytics/track', {
        estudio: estudio || 'general',
        source: 'fab',
        page: typeof window !== 'undefined' ? window.location.pathname : null,
      }).catch(() => {
        // Silenciar error: no queremos afectar UX si analytics falla
      });
    } catch (e) {
      // ignore
    }

    const url = `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="fixed bottom-5 right-5 z-50 flex items-end gap-3" data-testid="whatsapp-fab-wrapper">
      {showTooltip && (
        <div
          className="hidden sm:flex items-start gap-2 bg-white text-gray-900 rounded-xl px-4 py-3 shadow-2xl border border-gray-200 mb-1 max-w-xs animate-in fade-in slide-in-from-right-2 duration-300"
          data-testid="whatsapp-fab-tooltip"
        >
          <div className="text-sm leading-snug pr-4">
            <span className="font-semibold block mb-0.5">¿Necesitas ayuda?</span>
            <span className="text-gray-600">Escríbenos por WhatsApp</span>
          </div>
          <button
            onClick={() => setShowTooltip(false)}
            className="text-gray-400 hover:text-gray-600 shrink-0"
            aria-label="Cerrar"
            data-testid="whatsapp-fab-tooltip-close"
          >
            <X className="h-4 w-4" />
          </button>
          <span className="absolute -bottom-1.5 right-6 w-3 h-3 bg-white border-b border-r border-gray-200 rotate-45" />
        </div>
      )}

      <button
        onClick={handleClick}
        onMouseEnter={() => setShowTooltip(true)}
        aria-label="Contactar por WhatsApp"
        data-testid="whatsapp-fab-button"
        className="relative group h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white shadow-2xl shadow-green-600/40 flex items-center justify-center transition-transform duration-200 hover:scale-110 active:scale-95"
      >
        {pulse && (
          <>
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" style={{ animationDelay: '0.6s' }} />
          </>
        )}
        {/* WhatsApp logo SVG (más reconocible que lucide MessageCircle) */}
        <svg
          viewBox="0 0 24 24"
          className="relative h-7 w-7 sm:h-8 sm:w-8 fill-white"
          aria-hidden="true"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
        </svg>
      </button>
    </div>
  );
};

export default WhatsAppFab;
